import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import * as SvgIcons from '../../shared/SvgIcons';
import {
    FLASH_MESSAGE_TYPE_SUCCESS,
    FLASH_MESSAGE_TYPE_WARNING,
    FLASH_MESSAGE_TYPE_ERROR
} from '../../../config/constants';

import styles from './flashMessageContent.scss';

export function FlashMessageContent({ type, text, customIcon }) {

    // default to cancel icon
    let Icon = null;
    let style = '';

    if (customIcon) {
        Icon = SvgIcons[customIcon];
        style = 'custom-icon';
    }
    else if (type === FLASH_MESSAGE_TYPE_ERROR) {
        Icon = SvgIcons.CancelIcon;
        style = 'cancel-icon';
    }
    else if (type === FLASH_MESSAGE_TYPE_WARNING) {
        Icon = SvgIcons.AttentionIcon;
        style = 'attention-icon';
    }
    else if (type === FLASH_MESSAGE_TYPE_SUCCESS) {
        Icon = SvgIcons.ConfirmIcon;
        style = 'success-icon';
    }

    return (
        <div styleName={classNames('wrapper', type)}>
            {Icon && style && <Icon styleName={style} /> }
            <span dangerouslySetInnerHTML={{ __html: text }}></span>
        </div>
    );
}

FlashMessageContent.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    customIcon: PropTypes.string
};

export default CSSModules(FlashMessageContent, styles, { allowMultiple: true });
